<template>
  <Dialog
    :modal="true"
    v-model:visible="resquest_form"
    header="Disposal Form"
    @after-hide="IsClear"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '75vw' }"
  >
    <b-container fuild>
      <b-form @submit.prevent="IsSubmit">
        <!-- <b-row>
                    <b-col lg="3" class="field">
                        <div>
                            <p class="reason_disposal_heading text-dark">{{ t('assetManagement.Disposal.Asset Name')
                                }} : <span class="">{{ form.asset.AssetName }}</span></p>
                        </div>
                    </b-col>
                </b-row> -->
        <b-row>
          <!-- {{ autocompletelist }} -->
          <b-col lg="5" md="6" sm="6" cols="12" class="field mb-0">
            <div class="field">
              <label> Asset ID :</label>
              <AutoCompleteCustom
                v-model="form.asset"
                @input="LoadAsset()"
                name="Asset Id"
                :rules="{ required: true }"
                :required-icon="true"
                :items="autocompletelist"
                @item-select="assetidassign"
              />
            </div>
            <div>
              <h1 class="mb-4 reason_disposal_heading">
                {{
                  t("assetManagement.Disposal.ReasonforDisposal.ReasonDisposal")
                }}
              </h1>
              <div class="d-flex align-items-center">
                <RadioButton
                  v-model="form.reasonForDisposal"
                  inputId="Endoflife"
                  name="1"
                  :value="1"
                  :class="{ 'active-radio': form.reasonForDisposal === '1' }"
                />
                <label for="Endoflife" class="radio-label">{{
                  t("assetManagement.Disposal.ReasonforDisposal.Endoflife")
                }}</label>
              </div>
              <div class="d-flex align-items-center my-2">
                <RadioButton
                  v-model="form.reasonForDisposal"
                  inputId="Damagedbeyondrepair"
                  name="2"
                  :value="2"
                  :class="{ 'active-radio': form.reasonForDisposal === '2' }"
                />
                <label for="Damagedbeyondrepair" class="radio-label">{{
                  t(
                    "assetManagement.Disposal.ReasonforDisposal.Damagedbeyondrepair"
                  )
                }}</label>
              </div>
              <div class="d-flex align-items-center">
                <RadioButton
                  v-model="form.reasonForDisposal"
                  inputId="technology"
                  name="3"
                  :value="3"
                  :class="{ 'active-radio': form.reasonForDisposal === '3' }"
                />
                <label for="technology" class="radio-label">{{
                  t(
                    "assetManagement.Disposal.ReasonforDisposal.Obsoletetechnology"
                  )
                }}</label>
              </div>
              <div class="d-flex align-items-center my-2 mb-0">
                <RadioButton
                  v-model="form.reasonForDisposal"
                  inputId="Other"
                  name="4"
                  :value="4"
                  :class="{ 'active-radio': form.reasonForDisposal === '4' }"
                />
                <label for="Other" class="radio-label">{{
                  t("assetManagement.Disposal.ReasonforDisposal.Other")
                }}</label>
              </div>
            </div>
          </b-col>
          <b-col lg="7" md="6" sm="6" cols="12" v-if="form.assetID">
            <div class="mobile-card">
              <p>
                <span class="light-txt">Asset Name : </span>{{ form.AssetName }}
              </p>
              <p>
                <span class="light-txt">Group Name : </span
                >{{ form.ItemGroupName }}
              </p>
              <p>
                <span class="light-txt">Sub Group Name : </span
                >{{ form.ItemSubGroupName }}
              </p>
              <p>
                <span class="light-txt">SerialNumber : </span
                >{{ form.SerialNumber }}
              </p>
              <p><span class="light-txt">Tag Id : </span>{{ form.RFIDTag }}</p>
              <p>
                <span class="light-txt">AgreementPeriod : </span
                >{{ form.AgreementDetails }}
              </p>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="form.reasonForDisposal === '4'">
          <b-col lg="3">
            <div class="field mb-0">
              <TextArea
                :label="t('assetManagement.Disposal.OtherReason')"
                name="other reason"
                v-model="form.OtherReason"
              />
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col lg="3">
            <div class="field">
              <Dropdown
                :label="t('assetManagement.Disposal.DisposalMethod')"
                v-model="form.proposedDisposalMethod"
                :items="disposaloptions"
                :name="t('assetManagement.Disposal.DisposalMethod')"
                :rules="{ required: true }"
                :required-icon="true"
              />
            </div>
          </b-col>
        </b-row>
        <b-row v-if="form.proposedDisposalMethod === '1'">
          <b-col lg="3">
            <div class="field">
              <TextField
                type="text"
                v-model="form.expectedProceeds"
                :rules="{ required: true }"
                :required-icon="true"
                name="expectedproceeds"
                :label="t('assetManagement.Disposal.ExpectedProceeds')"
              />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <div class="field">
            <TextArea
              :label="t('assetManagement.Disposal.AdditionalNotes')"
              name="notes"
              v-model="notes"
            />
          </div>
        </b-row>
        <b-row>
          <Footer type="submit" @cancel="IsClear" label="Submit for Approval" />
        </b-row>
      </b-form>
    </b-container>
  </Dialog>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, computed, watch, onMounted } from "vue";
import Dropdown from "../../../../../../../components/FormComponents/Dropdown.vue";
import RadioButton from "primevue/radiobutton";
import TextArea from "../../../../../../../components/FormComponents/TextArea.vue";
import TextField from "../../../../../../../components/FormComponents/TextInput.vue";
import Footer from "../../../../../../../components/FormComponents/Footer.vue";
import AutoCompleteCustom from "../../../../../../../components/FormComponents/AutoComplete.vue";
import { DisposalModel } from "../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/model/Disposal/disposalModel";
import moment from "moment";
import DisposalService from "../../../../../../../modules/Inventory/Service/AssetManagement/DisposalService";
import AssetMasterService from "../../../../../../../modules/Inventory/Service/AssetManagement/AssetMasterService";
import CreateSuccessully from "../../../../../../../components/FormComponents/createdsuccessfully.vue";
import { useI18n } from "vue-i18n";
import { useForm } from "vee-validate";
import { number } from "yup";
import { useRouter, useRoute } from "vue-router";

export default defineComponent({
  components: {
    Dropdown,
    RadioButton,
    TextArea,
    TextField,
    Footer,
    AutoCompleteCustom,
    CreateSuccessully,
  },
  props: {
    resquest_form: {
      type: Boolean,
      default: false,
    },
    paramvalue: {
      type: Object,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const resquest_form = ref(props.resquest_form);
    const notes = ref();
    const other_reason = ref();
    const successpop = ref(false);
    const { handleSubmit, errors, resetForm, resetField } = useForm();
    const paramvalues: any = ref(props.paramvalue);
    const routes = useRoute();

    let StoreId = routes.query.Id;
    let BranchId = routes.query.BranchId;
    let usersData;
    let SessionUserData = localStorage.getItem("UsersData");
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    let HospitalId = Number(usersData.OrganizationId);
    const disposalMethods = {
      1: [{ name: "Scrap", value: 4 }],
      2: [
        { name: "Recycle", value: 2 },
        { name: "Scrap", value: 4 },
      ],
      3: [
        { name: "Donate", value: 3 },
        { name: "Recycle", value: 2 },
      ],
      4: [
        { name: "Recycle", value: 2 },
        { name: "Sell", value: 1 },
        { name: "Donate", value: 3 },
      ],
    };

    onMounted(() => {
      if (paramvalues.value?.AssetId) {
        form.value.asset = paramvalues.value.BarCode;
        assetidassign(paramvalues.value.AssetId);
      }
    });
    const disposaloptions = computed(() => {
      console.log("disposal_value", disposaloptions.value);
      form.value.proposedDisposalMethod = 0;
      form.value.OtherReason = "";
      return disposalMethods[form.value.reasonForDisposal] || [];
    });
    function closetrigger() {
      successpop.value = false;
      IsClear();
    }
    function IsClear() {
      Object.assign(form.value, copyform);
      resquest_form.value = false;
      emit("closepopup", resquest_form.value);
    }
    const form = ref<DisposalModel>({
      isNew: false,
      isModified: false,
      isDeleted: false,
      isActive: false,
      createdAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      modifiedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      createdBy: 0,
      modifiedBy: 0,
      createdByName: "",
      modifiedByName: "",
      entityId: 0,
      entityOperationId: 0,
      deptRoleId: 0,
      hospitalId: 0,
      branchId: 0,
      fromStoreBranchId: 0,
      toStoreBranchId: 0,
      isEntitySMS: 0,
      organizationName: "",
      branchName: "",
      fromStoreBranchName: "",
      toStoreBranchName: "",
      taskStatus: 0,
      taskExpiryDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      taskName: "",
      taskPriority: 0,
      responseTimeInHours: 0,
      isApprovalRequired: false,
      levelsOfApproval: 0,
      id: 0,
      asset: 0,
      assetID: 0,
      flaggedDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      reasonForDisposal: 0,
      proposedDisposalMethod: ref(),
      expectedProceeds: ref(),
      approvalStatus: "0",
      approvalDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      approvedBy: "",
      rejectionReason: "",
      ScheduledDisposalDate: "2024-10-28T00:00:00.000+05:30",
      assignedTo: 0,
      disposalInstructions: "",
      actualDisposalDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      actualDisposalMethod: "",
      actualDisposalProceeds: 0,
      buyerInformation: "",
      status: "1",
      disposalNotes: "",
      updatedBy: "",
      updatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      requiredDocumentation: "",
      disposalConfirmed: "",
      OtherReason: "",
      OrganizationName: "",
      Contact: "",
      Barcode: "",
      BarcodeNumber: 0,
      AssetName: "",
      ItemGroupName: "",
      ItemSubGroupName: "",
      SerialNumber: "",
      RFIDTag: "",
      AgreementDetails: "",
    });
    const copyform = JSON.parse(JSON.stringify(form.value));

    const autocompletelist = ref([]);
    console.log("values", form.value);
    const IsSubmit = handleSubmit(async () => {
      console.log("Form Values:", form.value);
      try {
        let msg;
        console.log("inside try:", form.value);
        const data_response = await DisposalService.createdata(form.value);
        console.log(data_response["result"]);
        msg = data_response["ErrorInfo"].ErrorCode;
        if (msg == null) {
          successpop.value = true;
        }
        console.log(data_response);
      } catch (error) {
        console.log(error);
      }
    });
    async function LoadAsset() {
      debugger;
      try {
        const data_response = await AssetMasterService.getAssetIdbyAutoComplete(
          form.value.asset,
          HospitalId,
          BranchId,
          StoreId
        );
        console.log(data_response);
        autocompletelist.value = data_response["result"]
          .filter(
            (item) =>
              item.StatusID !== 3 || item.StatusID !== 4 || item.StatusID !== 5
          )
          .map((item) => {
            item.label =
              item.AssetName +
              " | " +
              item.AssetDisplayId +
              " | " +
              item.BarCode;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        console.log(error);
      }
    }
    function assetidassign(data) {
      debugger;
      debugger;
      form.value.assetID = data.value.AssetId;
      form.value.Barcode = data.value.BarCode;
      form.value.BarcodeNumber = data.value.BarCodeNo;
      form.value.AssetName = data.value.AssetName;
      form.value.ItemGroupName = data.value.ItemGroupName;
      form.value.ItemSubGroupName = data.value.ItemSubGroupName;
      form.value.SerialNumber = data.value.SerialNumber;
      form.value.RFIDTag = data.value.RFIDTag;
      form.value.AgreementDetails = data.value.AgreementDetails;
    }
    return {
      resquest_form,
      IsClear,
      disposaloptions,
      notes,
      disposalMethods,
      form,
      IsSubmit,
      other_reason,
      LoadAsset,
      paramvalues,
      autocompletelist,
      BranchId,
      StoreId,
      usersData,
      assetidassign,
      successpop,
      closetrigger,
      t,
    };
  },
});
</script>
<style scoped>
.reason_disposal_heading {
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
}
</style>
